export default {
    myChatList: (state, getters, rootState, rootGetters) => {
        return state.myChatList;
    },
    chatNotification: (state, getters, rootState, rootGetters) => {
        return state.chatNotification;
    },
    whisperType: (state, getters, rootState, rootGetters) => {
        if (rootGetters["user/isParticipantRole"]()) {
            if (rootGetters['room/roomInfoSetting']?.useChatTargetOnlySpeaker) {
                return 'whisper';
            }
            if (rootGetters['room/roomInfoSetting']?.useChatTargetOnlyStaff) {
                return 'staff';
            }
        }
        if (!state.whisperType) {
            return 'all';
        }
        return state.whisperType;
    },
    systemMessage: (state, getters, rootState, rootGetters) => {
        return state.systemMessage;
    },
    whisperTarget: (state, getters, rootState, rootGetters) => {
        const ru = rootGetters['user/getRoomUser'](state.whisperTarget);
        if(ru){
            return state.whisperTarget;
        }
    },
    isExistsUnReadChat: (state, getters, rootState, rootGetters) => {
        return state.unReadChatLength !== 0;
    },
    unReadChatLength: (state, getters, rootState, rootGetters) => {
        return state.unReadChatLength
    }
}
